import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { MultiQuestionSectionComponentProps } from './types';

export const MultiQuestionGeneratedSection: FC<
  MultiQuestionSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
